import { useTranslation } from "react-i18next";

import { useCurrentDate } from "../../../../store/current-date/current-date.selectors";

import {
  calculateTimeDifference,
  formatTimeDifference,
  parseDate,
} from "../../../../utils/helpers";

import { IconSprite } from "../../../ui/IconSprite/IconSprite";
import { addStyles } from "./addStyles";

import { Divider } from "../../../ui/Divider/Divider.styled";
import { IconBox, Item, List, Text, Wrapper } from "./DateInfo.styled";

export const DateInfo = ({ date, colors }) => {
  const { t } = useTranslation();

  // const currentDate = new Date();
  const currentDate = new Date(useCurrentDate());

  const targetDate = parseDate(date);

  const { remainingMinutes } = calculateTimeDifference(targetDate, currentDate);

  const timeDiffString = formatTimeDifference(remainingMinutes);

  const data = [
    { text: date, icon: "calendar" },
    { text: `${timeDiffString} ${t("global.minute")}`, icon: "timer" },
  ];

  return (
    <Wrapper labelColor={colors.labelColor}>
      <Divider addStyles={addStyles(colors.dividerColor)} />
      <List>
        {data.map(({ text, icon }, ind) => (
          <Item key={ind}>
            <IconBox iconColor={colors.buttonText}>
              <IconSprite tag={icon} width="24" height="24" />
            </IconBox>

            <Text>{text}</Text>
          </Item>
        ))}
      </List>
    </Wrapper>
  );
};
